import React, { FunctionComponent, useCallback } from 'react';
import AccessoriesSection from './accessoriesSection/AccessoriesSection';
import { useDispatch, useSelector } from 'react-redux';
import optionsSelectors from '../../../../store/selectors/optionsSelectors';
import { carConfigurationActions } from '../../../../store/reducers/carConfigurationReducer';
import carConfigurationSelectors from '../../../../store/selectors/carConfigurationSelectors';
import ScrollToWrapper from '../../../presentational/ScrollToWrapper';
import useScrollToSection from '../../../../react/navigation/useScrollToSection';
import thunkActions from '../../../../store/actions/thunkActions';
import usePlatformConfig from '../../../../../common/react/usePlatformConfig';
import useBuildDealAccessoriesPayload from '../../../../react/controls/useBuildDealAccessoriesPayload';
import { ROUTES } from '../../../../../common/constants/routes';
import useWidgetContext from '../../../../../common/react/useWidgetContext';

const AccessoriesContainer: FunctionComponent = () => {
  const optionsLoading = useSelector(optionsSelectors.getOptionsLoadingState);
  const optionsError = useSelector(optionsSelectors.getOptionsErrorState);
  const options = useSelector(optionsSelectors.getOptions);
  const accessoriesCategories = useSelector(optionsSelectors.getAccessoriesCategories);
  const dispatch = useDispatch();
  const currentSelectedAccessories = useSelector(carConfigurationSelectors.getSelectedAccessories);
  const { scrollToDisclaimer } = useScrollToSection();
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const { buildDealAccessoriesPayload } = useBuildDealAccessoriesPayload(ROUTES.CONFIGURE);
  const {
    configuration: { dimensions },
  } = useWidgetContext();

  const toggleAccessory = useCallback(
    async (option: string) => {
      // @TODO: !! Please refactor code in a way that the callback to accessory clicks is not depending on
      // state that is changed in this callback. This callback should only change a state and do nothing more.
      // The current issue is that all accessory item components are re-rendered on every toggle of any accessory.

      const initRequest = buildDealAccessoriesPayload(option);
      const { payload } = (await dispatch(thunkActions.initBasket({ initRequest, priceDisplay, dimensions }))) as any;
      if (payload) {
        // @TODO: Refactor when deal decoupled from basket.
        dispatch(carConfigurationActions.setDataFromDeal(payload.deal));
      }
    },
    [buildDealAccessoriesPayload, priceDisplay],
  );

  if (!optionsLoading && !optionsError && options?.accessories?.count === 0) {
    return null;
  }

  return (
    <ScrollToWrapper target="accessories" data-test={'container:section:accessories'}>
      <AccessoriesSection
        selectedAccessories={currentSelectedAccessories}
        isSearch={false}
        accessoriesTotal={options?.accessories?.count}
        onClick={toggleAccessory}
        accessoriesCategories={accessoriesCategories}
        searchedAccessories={[]}
        error={optionsError}
        loading={optionsLoading}
        onIndicativeClick={scrollToDisclaimer}
      />
    </ScrollToWrapper>
  );
};

export default AccessoriesContainer;
